import currencyJs from 'currency.js'

export const getCurrencySymbol = (currency: string): string => {
    switch (currency) {
        case 'CZK':
            return 'Kč'
        case 'EUR':
            return '€'
        default:
            return currency
    }
}

export const formatPrice = (
    amount: string,
    currency: string,
    forceSign: boolean = false,
    minimumPrecision?: number
) => {
    const amountPrecision = Number.isInteger(Number(amount)) ? 0 : 2
    const resolvedPrecision = Math.max(minimumPrecision ?? 0, amountPrecision)
    const positivePattern = forceSign ? '+# !' : '# !'

    return currencyJs(amount, { precision: resolvedPrecision }).format({
        separator: ' ',
        decimal: ',',
        pattern: positivePattern,
        symbol: getCurrencySymbol(currency),
        negativePattern: '-# !',
    })
}
